import api from './api'

// Generate or get session ID
function getSessionId(): string {
  let sessionId = sessionStorage.getItem('session_id')
  
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2)}`
    sessionStorage.setItem('session_id', sessionId)
  }
  
  return sessionId
}

// Track page view
export async function trackPageView(orderId?: string) {
  try {
    const sessionId = getSessionId()
    
    await api.post('/api/track', {
      sessionId,
      orderId,
      pageUrl: window.location.pathname + window.location.search,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screen: {
        width: window.screen.width,
        height: window.screen.height
      }
    })
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking failed:', error)
  }
}

// Track payment click (Pagado button)
export async function trackPaymentClick(orderId: string) {
  try {
    await api.post('/api/track/payment-click', {
      orderId
    })
  } catch (error) {
    console.debug('Payment click tracking failed:', error)
  }
}

// Track on page load
if (typeof window !== 'undefined') {
  // Track initial page view
  window.addEventListener('load', () => {
    const pathParts = window.location.pathname.split('/')
    const orderId = pathParts[pathParts.length - 1]
    
    if (orderId && orderId.length > 10) {
      trackPageView(orderId)
    } else {
      trackPageView()
    }
  })
}

